<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
     <!-- Add button -->
     <div class="text-right">
      <b-button v-b-modal.modal-folio 
                        variant="primary">
                        <i class="ni ni-fat-add"></i> {{ $t('ingresar_folio') }}
                    </b-button>
      </div>  
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <FolioTable/>
        </b-col>
      </b-row>
    </b-container>

    
    <b-modal id="modal-folio" size="s" scrollable title="Ingreso de Folio PDI" @ok="ingresarFolio"
        no-close-on-backdrop :ok-title="$t('guardar')">
        <b-row class="justify-content-center">
            <b-col cols="8">
                <b-form-group label="Folio PDi" label-for="numero-input">
                    <template v-slot:label>
                        {{ $t('folio_pdi') }} <span class="text-danger">*</span>
                    </template>
                    <b-form-input id="folio-input" type="number" v-model="folio.folioPDI" required
                        :state="folio.folioPDI ? true : null" placeholder="ingrese Folio">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </b-modal>
  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
import FolioTable from './FolioTable.vue';
import folioService from '@/api/folioService';

  export default {
    components: {
      FolioTable,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data(){
      return {
        folio: { folioPDI : ''}
      }
    },
    methods:{
      ingresarFolio(){

          //funcion validar folio unico

            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('guardar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    try {
                      const response = await folioService.create(this.folio);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    Swal.fire({
                        title: this.$t('cambios_guardados'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                    

                    location.reload();
                  } catch (error) {

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message
            });
          }
          this.folio.folioPDI = '';
                }
            });
        }
    }
  };
</script>
<style>
.el-table.table-dark{
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr{
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf{
  border-bottom: none;
}
</style>
